// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.85);
  -webkit-backdrop-filter: blur(8px);
          backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99999;
  animation: fadeIn 0.3s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.error-content {
  text-align: center;
  padding: 40px;
  max-width: 400px;
  background: var(--ion-card-background, #1e1e1e);
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);
  animation: slideUp 0.4s ease-out;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.error-icon-container {
  margin-bottom: 24px;
}

.error-icon {
  font-size: 72px;
  color: var(--ion-color-danger, #eb445a);
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.7;
    transform: scale(1.05);
  }
}
.error-title {
  font-size: 24px;
  font-weight: 600;
  color: var(--ion-text-color, #ffffff);
  margin: 0 0 12px 0;
}

.error-message {
  font-size: 15px;
  color: var(--ion-color-medium, #92949c);
  margin: 0 0 28px 0;
  line-height: 1.5;
}

.retry-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 14px 32px;
  font-size: 16px;
  font-weight: 600;
  color: #ffffff;
  background: var(--ion-color-primary, #3880ff);
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 160px;
}
.retry-button:hover:not(:disabled) {
  background: var(--ion-color-primary-shade, #3171e0);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(56, 128, 255, 0.4);
}
.retry-button:active:not(:disabled) {
  transform: translateY(0);
}
.retry-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}
.retry-button ion-icon {
  font-size: 20px;
}
.retry-button ion-spinner {
  width: 20px;
  height: 20px;
}

.error-hint {
  font-size: 13px;
  color: var(--ion-color-medium-shade, #808289);
  margin: 20px 0 0 0;
}

:host-context(body:not(.dark)) .error-overlay {
  background: rgba(255, 255, 255, 0.9);
}
:host-context(body:not(.dark)) .error-content {
  background: #ffffff;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
}
:host-context(body:not(.dark)) .error-title {
  color: #1a1a1a;
}
:host-context(body:not(.dark)) .error-message {
  color: #666666;
}
:host-context(body:not(.dark)) .error-hint {
  color: #888888;
}

@media (max-width: 480px) {
  .error-content {
    margin: 20px;
    padding: 30px 24px;
  }
  .error-icon {
    font-size: 56px;
  }
  .error-title {
    font-size: 20px;
  }
  .error-message {
    font-size: 14px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/error-overlay/error-overlay.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,+BAAA;EACA,kCAAA;UAAA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,+BAAA;AACF;;AAEA;EACE;IACE,UAAA;EACF;EACA;IACE,UAAA;EACF;AACF;AAEA;EACE,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,+CAAA;EACA,mBAAA;EACA,0CAAA;EACA,gCAAA;AAAF;;AAGA;EACE;IACE,UAAA;IACA,2BAAA;EAAF;EAEA;IACE,UAAA;IACA,wBAAA;EAAF;AACF;AAGA;EACE,mBAAA;AADF;;AAIA;EACE,eAAA;EACA,uCAAA;EACA,4BAAA;AADF;;AAIA;EACE;IACE,UAAA;IACA,mBAAA;EADF;EAGA;IACE,YAAA;IACA,sBAAA;EADF;AACF;AAIA;EACE,eAAA;EACA,gBAAA;EACA,qCAAA;EACA,kBAAA;AAFF;;AAKA;EACE,eAAA;EACA,uCAAA;EACA,kBAAA;EACA,gBAAA;AAFF;;AAKA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,6CAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;AAFF;AAIE;EACE,mDAAA;EACA,2BAAA;EACA,8CAAA;AAFJ;AAKE;EACE,wBAAA;AAHJ;AAME;EACE,YAAA;EACA,mBAAA;AAJJ;AAOE;EACE,eAAA;AALJ;AAQE;EACE,WAAA;EACA,YAAA;AANJ;;AAUA;EACE,eAAA;EACA,6CAAA;EACA,kBAAA;AAPF;;AAYE;EACE,oCAAA;AATJ;AAYE;EACE,mBAAA;EACA,2CAAA;AAVJ;AAaE;EACE,cAAA;AAXJ;AAcE;EACE,cAAA;AAZJ;AAeE;EACE,cAAA;AAbJ;;AAkBA;EACE;IACE,YAAA;IACA,kBAAA;EAfF;EAkBA;IACE,eAAA;EAhBF;EAmBA;IACE,eAAA;EAjBF;EAoBA;IACE,eAAA;EAlBF;AACF","sourcesContent":[".error-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.85);\n  backdrop-filter: blur(8px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 99999;\n  animation: fadeIn 0.3s ease-out;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.error-content {\n  text-align: center;\n  padding: 40px;\n  max-width: 400px;\n  background: var(--ion-card-background, #1e1e1e);\n  border-radius: 16px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);\n  animation: slideUp 0.4s ease-out;\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.error-icon-container {\n  margin-bottom: 24px;\n}\n\n.error-icon {\n  font-size: 72px;\n  color: var(--ion-color-danger, #eb445a);\n  animation: pulse 2s infinite;\n}\n\n@keyframes pulse {\n  0%, 100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n  50% {\n    opacity: 0.7;\n    transform: scale(1.05);\n  }\n}\n\n.error-title {\n  font-size: 24px;\n  font-weight: 600;\n  color: var(--ion-text-color, #ffffff);\n  margin: 0 0 12px 0;\n}\n\n.error-message {\n  font-size: 15px;\n  color: var(--ion-color-medium, #92949c);\n  margin: 0 0 28px 0;\n  line-height: 1.5;\n}\n\n.retry-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 14px 32px;\n  font-size: 16px;\n  font-weight: 600;\n  color: #ffffff;\n  background: var(--ion-color-primary, #3880ff);\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  min-width: 160px;\n\n  &:hover:not(:disabled) {\n    background: var(--ion-color-primary-shade, #3171e0);\n    transform: translateY(-2px);\n    box-shadow: 0 4px 12px rgba(56, 128, 255, 0.4);\n  }\n\n  &:active:not(:disabled) {\n    transform: translateY(0);\n  }\n\n  &:disabled {\n    opacity: 0.7;\n    cursor: not-allowed;\n  }\n\n  ion-icon {\n    font-size: 20px;\n  }\n\n  ion-spinner {\n    width: 20px;\n    height: 20px;\n  }\n}\n\n.error-hint {\n  font-size: 13px;\n  color: var(--ion-color-medium-shade, #808289);\n  margin: 20px 0 0 0;\n}\n\n// Light theme adjustments\n:host-context(body:not(.dark)) {\n  .error-overlay {\n    background: rgba(255, 255, 255, 0.9);\n  }\n\n  .error-content {\n    background: #ffffff;\n    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);\n  }\n\n  .error-title {\n    color: #1a1a1a;\n  }\n\n  .error-message {\n    color: #666666;\n  }\n\n  .error-hint {\n    color: #888888;\n  }\n}\n\n// Responsive\n@media (max-width: 480px) {\n  .error-content {\n    margin: 20px;\n    padding: 30px 24px;\n  }\n\n  .error-icon {\n    font-size: 56px;\n  }\n\n  .error-title {\n    font-size: 20px;\n  }\n\n  .error-message {\n    font-size: 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
